<script>
import { Validator } from 'simple-vue3-validator'
import axios from 'axios';
import useAppRouter from '../../composables/useAppRouter';

export default {
  data(){
    return{
      email_receive:'',
      serverMessage: '',
      router: useAppRouter,
    }
  },
  
  watch: {
    email_receive: function() {
      this.serverMessage = "";
    }
  },

  methods:{
    async executeForgotPassword() {
      return axios.post('/account/forgot-password',
        {
          email: this.email_receive 
        },
        {
          headers: {
            'Content-Type': 'application/json',
          }
        }
      )
    },
    async submit_form(){
      var vm = this;
      var success = await this.$validate();

      if (success) {
        try {
          var res = await vm.executeForgotPassword();
          if (res !== undefined && res.status === 200 && res.data.url && res.data.url.toLowerCase() === "logon") {
            return this.router().show('login', { tempUserFeedback: "A reset password email has been sent to the nominated email address." })
          }
          if (res.data.TempData["Status.Css"] && res.data.TempData["Status.Css"].toLowerCase() == "error") {
            vm.serverMessage = res.data.TempData["Status.Message"];
            return;
          }
        }
        catch (err) {
          console.log("Errored response: " + err);
        }
      }
    }
  },
  validators:{
    email_receive: function(value){
      return Validator.value(value).required().email();
    }
  }
}
</script>
